import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "fileType-damage",
  "use": "fileType-damage-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"fileType-damage\"><defs><symbol id=\"fileType-damage_a\" data-name=\"file-break\" viewBox=\"0 0 20 20\"><path d=\"M15.77 0H7.68l1.06 4.53-2.21 4.63.11 5.58-1.38-5.58 2-4.63L5.72 0H0v20h20V4.23zm0 4.37V.28l4.08 4.08z\" fill=\"#bfbfbf\" /></symbol></defs><title>fileType-damage</title><g data-name=\"图层 2\"><use width=\"20\" height=\"20\" xlink:href=\"#fileType-damage_a\" data-name=\"图层 1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/fileType-damage.svg
// module id = Gri2
// module chunks = 6